import { Injectable } from '@angular/core';
import { HttpService } from '../../shared/service/http.service';
import { JiraTicket } from '../model/jira-ticket';
import { FindHttpError } from '../../shared/error/find-http-error';
import { Observable } from 'rxjs/Observable';
import { HttpError } from '../../shared/error/http-error';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class JiraTicketService {
  private JIRA_TICKET_END_POINT = '/integration/jira/findJiraIssue';

  find$: Observable<JiraTicket>;
  error$: Observable<HttpError>;

  private findSubject: Subject<JiraTicket>;
  private errorSubject: Subject<any>;

  constructor(private _httpService: HttpService) {
    this.findSubject = new Subject();
    this.find$ = this.findSubject.asObservable();
    this.errorSubject = new Subject();
    this.error$ = this.errorSubject.asObservable();
  }

  findJiraTicket(typedValue) {
    this._httpService.get(`${this.JIRA_TICKET_END_POINT}/${typedValue}`, JiraTicket, FindHttpError)
      .subscribe(
        ticket => this.findSubject.next(ticket),
        error => {
          error.text = 'Não foi possível recuperar os dados desse ticket!';
          this.errorSubject.next(error);
      });
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/appraisal/service/jira-ticket.service.ts